export default __webpack_public_path__ + "774ced0cd0abc65d0c1887da89f50505.jpeg";